module.exports = __webpack_public_path__ + "img/logo-dual-tone.db611e64.svg";